import { render, staticRenderFns } from "./CmgOrderConfirmationCreateAccount.vue?vue&type=template&id=9ddf0bc2&scoped=true&lang=pug&"
import script from "./cmg-order-confirmation-create-account.ts?vue&type=script&lang=ts&"
export * from "./cmg-order-confirmation-create-account.ts?vue&type=script&lang=ts&"
import style0 from "./CmgOrderConfirmationCreateAccount.vue?vue&type=style&index=0&id=9ddf0bc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddf0bc2",
  null
  
)

export default component.exports